const postEquipmentsStr = {
  toastr: 'Equipo agregado',
  toastr1: 'El equipo fue agregado con éxito.',
  toastrError: 'Equipo ya registrado',
  toastrError1: 'Ingrese este CNPJ o Nombre ya registrado',
  toastrError2: 'Error al crear Equipo',
  serialNumberError: 'Ya existe un equipo con el mismo número de serie para este sitio',
};

export default postEquipmentsStr;
